<template>
  <div class="survey-question-checkbox">
    <label
      v-for="option in question.options"
      :key="option"
      class="survey-question-checkbox__label"
    >
      <SurveyCheckbox
        :checked="modelValue.includes(option)"
        :on-change="() => onChange(option)"
      />
      <span class="survey-question-checkbox__text">{{ option }}</span>
    </label>
  </div>
</template>

<script>
import SurveyCheckbox from "@/views/Components/Atoms/TicketStore/Survey/SurveyCheckbox.vue";

export default {
  name: "SurveyQuestionCheckbox",
  components: { SurveyCheckbox },
  props: {
    modelValue: {
      type: Array,
      default: () => [],
    },
    question: {
      type: Object,
      required: true,
    },
    onChange: {
      type: Function,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./_survey.scss";

.survey-question-checkbox {
  @extend %survey-question-option-list;
  padding-left: 22px;

  &__label {
    @extend %survey-question-option-list__label;
  }
}
</style>
